<template>
  <PopModal ref="modal" :title="$t('佣金转余额')">
    <div class="container pa-3">
      <div class="card bg-template bg-blue">
        <div class="card-body">
          <div class="row justify-center pl-2 pr-2">
            <div class="text-center">
              <div class="mb-0 font-weight-normal ft-26">
                {{ formatMoney(userMoney.balance2, currency, true) }}
              </div>
              <p class="text-mute">{{ $t("佣金余额") }}</p>
            </div>
          </div>
        </div>
      </div>

      <van-field
          v-model="formObj.money"
          :label="$t('转入金额')"
          :placeholder="$t('不填则全部转入')"
          autocomplete="off"
          type="number"
      />
      <van-field
          v-if="needPassword"
          v-model="formObj.password"
          :label="$t('提款密码')"
          :placeholder="$t('please_input_withdraw_password')"
          type="password"
      />
      <div class="d-flex justify-end" style="padding: 8px 16px 0;">
        <van-button size="mini" plain type="primary" @click="fillAll">
          {{ $t("全部转入") }}
        </van-button>
      </div>
      <div style="margin: 16px;">
        <van-button
            :loading="loading"
            :loading-text="$t('submitting')"
            block
            round
            small
            type="primary"
            @click="submit"
        >
          {{ $t("submit") }}
        </van-button>
      </div>
    </div>
  </PopModal>
</template>
<script>
import PopModal from "@/components/PopModal.vue";
import {transfer2Balance} from "@/api/user";

export default {
  name: 'CommissionConvertModal',
  components: {
    PopModal
  },
  computed: {
    ...Vuex.mapGetters([
      "currency",
      "userMoney",
      "paramMapAll"
    ]),
    needPassword() {
      return this.paramMapAll['COMMISSION_CONVERT_TK_PASSWORD'] === '1';
    },
  },
  data() {
    return {
      formObj: {money: null, password: null},
      loading: false,
    };
  },
  methods: {
    show() {
      this.formObj = {money: null, password: null};
      this.$refs.modal.show();
    },
    fillAll() {
      this.formObj.money = this.userMoney.balance2;
    },
    submit() {
      if (this.loading) return;
      const moneyStr = String(this.formObj.money == null ? '' : this.formObj.money).trim();
      if (moneyStr !== '') {
        if (!/^(\d+(\.\d{1,2})?)$/.test(moneyStr)) {
          this.$toast.fail(this.$t("转入金额格式错误"));
          return;
        }
        const money = parseFloat(moneyStr);
        if (money <= 0) {
          this.$toast.fail(this.$t("转入金额格式错误"));
          return;
        }
        if (money > Number(this.userMoney.balance2)) {
          this.$toast.fail(this.$t("余额不足"));
          return;
        }
      }
      if (this.needPassword) {
        const pwd = this.formObj.password || '';
        if (!/^.{4,16}$/.test(pwd)) {
          this.$toast.fail(this.$t("withdraw_password_format_error"));
          return;
        }
      }
      this.loading = true;
      transfer2Balance({
        money: moneyStr === '' ? null : parseFloat(moneyStr),
        password: this.formObj.password || null,
      })
          .then(() => {
            this.$toast.success(this.$t("转入成功"));
            this.$refs.modal.hide();
            this.$store.dispatch("user/getUserMoney");
          })
          .catch(() => {
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
};
</script>
<style scoped>
.justify-center {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.ft-26 {
  font-size: 40px;
}

.text-mute {
  opacity: 0.7;
}
</style>
